<template>
  <div>
    <h1>룬워드 검색</h1>
    <p>
      <a
        href="https://namu.wiki/w/%EB%A3%AC%EC%96%B4%20%EC%95%84%EC%9D%B4%ED%85%9C"
        target="_blank"
        >나무위키의 디아블로2 룬어 아이템 데이터</a
      >를 참고하여 작성되었습니다.<br />
      데이터는
      <a
        href="https://github.com/luversof/luversof.github.io/tree/main/diablo2/"
        target="_blank"
        >이곳</a
      >에 수정을 요청하면 됩니다.
    </p>

    <hr />

    <h2 @click="toggleIsShowRuneFilter" role="button">
      룬 필터
      <font-awesome-icon
        :icon="isShowRuneFilter ? 'caret-square-up' : 'caret-square-down'"
      />
    </h2>
    <div
      class="collapse collapse-horizontal"
      :class="isShowRuneFilter ? 'show' : ''"
    >
      <p>선택한 룬들을 함께 사용한 룬워드 목록을 보여줍니다. (and 조건)</p>
      <button
        class="btn btn-dark btn-sm m-1"
        :class="selectedRuneIdList.length > 0 ? '' : 'disabled'"
        @click="clearSelectedRuneIdList"
      >
        룬 필터 해제
      </button>
      <br />
      <RuneButton
        class="btn btn-outline-dark m-1"
        v-for="rune in runeList"
        :key="rune.id"
        :id="rune.id"
        :class="isSelectedRuneId(rune.id) ? 'active' : ''"
        @click="toggleSelectedRuneId(rune.id)"
      />
    </div>

    <hr />

    <h2 @click="toggleIsShowItemCategoryFilter" role="button">
      아이템 카테고리 필터
      <font-awesome-icon
        :icon="
          isShowItemCategoryFilter ? 'caret-square-up' : 'caret-square-down'
        "
      />
    </h2>
    <div
      class="collapse collapse-horizontal"
      :class="isShowItemCategoryFilter ? 'show' : ''"
    >
      <p>
        선택한 아이템 카테고리에 해당하는 룬워드 목록을 보여줍니다. (or 조건)
      </p>
      <button
        class="btn btn-dark btn-sm m-1"
        :class="selectedItemCategoryNameList.length > 0 ? '' : 'disabled'"
        @click="clearSelectedItemCategoryNameList"
      >
        아이템 카테고리 필터 해제
      </button>
      <br />
      <ItemCategoryButton
        class="btn-outline-dark m-1"
        v-for="itemCategoryName in targetItemCategoryNameList"
        :key="itemCategoryName"
        :itemCategoryName="itemCategoryName"
        :class="isSelectedItemCategoryName(itemCategoryName) ? 'active' : ''"
        @click="toggleSelectedItemCategoryName(itemCategoryName)"
      />
    </div>

    <hr />

    <h2 @click="toggleIsShowSocketCountFilter" role="button">
      소켓 수 필터
      <font-awesome-icon
        :icon="
          isShowSocketCountFilter ? 'caret-square-up' : 'caret-square-down'
        "
      />
    </h2>
    <div
      class="collapse collapse-horizontal"
      :class="isShowSocketCountFilter ? 'show' : ''"
    >
      <p>
        선택한 소켓 수에 해당하는 룬워드 목록을 보여줍니다. (or 조건)
      </p>
      <button
        class="btn btn-dark btn-sm  m-1"
        :class="selectedSocketCountList.length > 0 ? '' : 'disabled'"
        @click="clearSelectedSocketCountList"
      >
        소켓 수 필터 해제
      </button>
      <br />
      <div class="form-check form-check-inline  m-1">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedSocketCountList"
          @click="toggleSelectedSocketCountList"
          value="2"
          id="selectedSocketCount2"
        /><label class="form-check-label" for="selectedSocketCount2">2</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedSocketCountList"
          @click="toggleSelectedSocketCountList"
          value="3"
          id="selectedSocketCount3"
        /><label class="form-check-label" for="selectedSocketCount3">3</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedSocketCountList"
          @click="toggleSelectedSocketCountList"
          value="4"
          id="selectedSocketCount4"
        /><label class="form-check-label" for="selectedSocketCount4">4</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedSocketCountList"
          @click="toggleSelectedSocketCountList"
          value="5"
          id="selectedSocketCount5"
        /><label class="form-check-label" for="selectedSocketCount5">5</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedSocketCountList"
          @click="toggleSelectedSocketCountList"
          value="6"
          id="selectedSocketCount6"
        /><label class="form-check-label" for="selectedSocketCount6">6</label>
      </div>
    </div>

    <hr />

    <h2 @click="toggleIsShowRecommandFilter" role="button">
      추천 아이템 필터
      <font-awesome-icon
        :icon="isShowRecommandFilter ? 'caret-square-up' : 'caret-square-down'"
      />
    </h2>
    <div
      class="collapse collapse-horizontal"
      :class="isShowRecommandFilter ? 'show' : ''"
    >
      <p>
        나무위키 추천 아이템 입니다.<br />
        선택한 추천 아이템에 해당하는 룬워드 목록을 보여줍니다.
      </p>
      <button
        class="btn btn-dark btn-sm  m-1"
        :class="selectedRecommandList.length > 0 ? '' : 'disabled'"
        @click="clearSelectedRecommandList"
      >
        추천 아이템 필터 해제
      </button>
      <br />
      <div class="form-check form-check-inline m-1">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedRecommandList"
          @click="toggleSelectedRecommandList"
          value="leveling"
          id="selectedRecommand1"
        /><label class="form-check-label" for="selectedRecommand1"
          >레벨링</label
        >
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedRecommandList"
          @click="toggleSelectedRecommandList"
          value="final"
          id="selectedRecommand2"
        /><label class="form-check-label" for="selectedRecommand2">졸업</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedRecommandList"
          @click="toggleSelectedRecommandList"
          value="mercenary"
          id="selectedRecommand3"
        /><label class="form-check-label" for="selectedRecommand3">용병</label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="checkbox"
          v-model="selectedRecommandList"
          @click="toggleSelectedRecommandList"
          value="swap"
          id="selectedRecommand4"
        /><label class="form-check-label" for="selectedRecommand4"
          >스왑용</label
        >
      </div>
    </div>

    <hr />

    <input
      type="text"
      class="form-control m-1"
      :value="searchKeyword"
      @input="changeSearchKeyword"
      placeholder="검색어를 입력하세요. 복수 검색도 가능합니다. 예) 통찰,무한"
    />

    <RunewordList />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

import RuneButton from "@/components/diablo2/RuneButton.vue";
import ItemCategoryButton from "@/components/diablo2/ItemCategoryButton.vue";
import RunewordList from "@/components/diablo2/RunewordList.vue";

export default {
  components: { RuneButton, ItemCategoryButton, RunewordList },
  data() {
    return {
      targetItemCategoryNameList: [
        "melee weapon",
        "ranged weapon",
        "axe",
        "sword",
        "polearm",
        "staff",
        "mace",
        "katar",
        "chest armor",
        "head armor",
        "shield",
      ],
    };
  },
  computed: {
    ...mapState({
      runeList: (state) => state.diablo2.rune.runeList,
      itemCategoryList: (state) => state.diablo2.itemCategory.itemCategoryList,

      isShowRuneFilter: (state) =>
        state.diablo2.runewordSearch.isShowRuneFilter,
      selectedRuneIdList: (state) =>
        state.diablo2.runewordSearch.selectedRuneIdList,

      isShowItemCategoryFilter: (state) =>
        state.diablo2.runewordSearch.isShowItemCategoryFilter,
      selectedItemCategoryNameList: (state) =>
        state.diablo2.runewordSearch.selectedItemCategoryNameList,

      isShowSocketCountFilter: (state) =>
        state.diablo2.runewordSearch.isShowSocketCountFilter,
      selectedSocketCountList: (state) =>
        state.diablo2.runewordSearch.selectedSocketCountList,

      isShowRecommandFilter: (state) =>
        state.diablo2.runewordSearch.isShowRecommandFilter,
      selectedRecommandList: (state) =>
        state.diablo2.runewordSearch.selectedRecommandList,

      searchKeyword: (state) => state.diablo2.runewordSearch.searchKeyword,
    }),
    ...mapGetters("diablo2/runewordSearch", [
      "isSelectedRuneId",
      "isSelectedItemCategoryName",
    ]),
  },
  methods: {
    ...mapMutations("diablo2/runewordSearch", [
      "toggleIsShowRuneFilter",
      "toggleSelectedRuneId",
      "clearSelectedRuneIdList",

      "toggleIsShowItemCategoryFilter",
      "toggleSelectedItemCategoryName",
      "clearSelectedItemCategoryNameList",

      "toggleIsShowSocketCountFilter",
      "toggleSelectedSocketCountList",
      "clearSelectedSocketCountList",

      "toggleIsShowRecommandFilter",
      "toggleSelectedRecommandList",
      "clearSelectedRecommandList",

      "changeSearchKeyword",
    ]),
  },
};
</script>

<style></style>
